// extracted by mini-css-extract-plugin
export default {"container":"DocumentCampaign_container__-USHM"};